import BMUI from '@bm/bmui3';
import CdnImg from '~/frontend-shared/components/CdnImg';
// import vSelect from 'vue-select';

import '@bm/bmui3/lib/index.less';
// import 'vue-select/dist/vue-select.css';

// import '@bm/bmui3/lib/icon/icon.less';
import Clickoutside from '@bm/bmui3/lib/assets/utils/clickoutside.js';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('clickoutside', Clickoutside);
  nuxtApp.vueApp.use(BMUI);
  nuxtApp.vueApp.component('CdnImg', CdnImg);
  // nuxtApp.vueApp.component('v-select', vSelect)

});
